import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import {dashboardRoutes} from '../../../routes/routes';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import Icon from '@material-ui/core/Icon';
import "./Footer.css";

const drawerWidth = 180;
const drawerList = ['Dashboard', 'Users', 'Admins'] //'User Grouping'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper : {
    background: '#00BBBB'
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      
      marginLeft: drawerWidth,
    },
    background: '#F0FBFB',
    
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  menuButton1: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    background: '#00BBBB',
    width: drawerWidth,
    color: 'blue'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function ResponsiveDrawer(props) {
  const {window} = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const iconSetter = (index) => {
    if(index === 0) {
      return <DashboardIcon style={{ color: 'white'}}/>;
    }
    else if (index === 1) {
      return <DateRangeIcon style={{ color: 'white'}}/>;
    } 
    else if (index === 2) {
      return <PersonIcon style={{ color: 'white'}}/>;
    }
    else if (index === 3) {
      return <SupervisorAccountIcon style={{ color: 'white'}}/>;
    }
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} /> 
      <div><object data="tcdlogo.png" height='87px' width='170px' style={{marginTop:'-12px', marginBottom:'35px'}}> </object></div>      
      <List>
        {drawerList.map((text, index) => (
           <ListItem button key={text} style={{color: 'white', backgroundColor: '#00BBBB'}} component={Link}  to={"/" + text}>            
           <ListItemIcon>{iconSetter(index) }</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <h3 className = {classes.menuButton1} style={{color: '#00BBBB'}}>{}</h3>
          <IconButton
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
            
          </IconButton>
        </Toolbar>
      </AppBar>
      <Router>
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}

            <Link to="/Logout" className="main-footer">
      <Icon style={{marginLeft: '15px'}}>
  <img src="logout.svg" alt="Logout icon"/>
    </Icon>
       <h3 style={{color:'white', marginTop: '-28px', marginLeft: '70px', fontWeight: 'inherit'}}>Logout</h3>
    </Link>

          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.paper,
            }}
            variant="permanent"
            open
          >
            {drawer}
            <Link to="/Logout" className="main-footer">
      <Icon style={{marginLeft: '15px'}}>
  <img src="logout.svg" alt="Logout icon"/>
    </Icon>
       <h3 style={{color:'white', fontWeight: 'inherit', marginTop: '-28px', marginLeft: '70px',}}>Logout</h3>
    </Link>
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content} style={{
  // backgroundImage: `url(${"Dashboard_BG.svg"})`,
   top: '0',
   width: '100%',
   height: '100%',
   backgroundSize: 'cover',
   opacity: '100%'
   }}>
        <div className={classes.toolbar} />
      {dashboardRoutes}
      </main>
      </Router>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
